import type {
  CreateProposalArgs,
  ModerateArgs,
  ProposalRow,
  ProposalUser,
} from '../../types/coinProposals';
import type { ApiStatusResponse } from '../../types/orders';
import { apiUrl, parseJsonOrThrow } from '../http';

const ENDPOINT = '/php/coin-proposals.php';

interface ProposalListResponse<T> extends ApiStatusResponse {
  data?: T[] | null;
  message?: string;
}

interface ProposalActionResponse extends ApiStatusResponse {
  message?: string;
}

/** POST a JSON `action` payload and parse the response, throwing on `status: 'error'`. */
const postAction = async <T extends ApiStatusResponse & { message?: string }>(
  body: Record<string, unknown>
): Promise<T> => {
  const res = await fetch(apiUrl(ENDPOINT), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const result = await parseJsonOrThrow<T>(res);
  if (result.status === 'error') {
    throw new Error(result.message ?? 'Помилка модуля пропозицій');
  }
  return result;
};

export const getProposalUsers = async (): Promise<ProposalUser[]> => {
  const result = await postAction<ProposalListResponse<ProposalUser>>({
    action: 'get_users',
  });
  return result.data ?? [];
};

export const createProposal = (
  args: CreateProposalArgs
): Promise<ProposalActionResponse> =>
  postAction<ProposalActionResponse>({ action: 'create', ...args });

export const getProposalsAdminList = async (): Promise<ProposalRow[]> => {
  const result = await postAction<ProposalListResponse<ProposalRow>>({
    action: 'admin_list',
  });
  return result.data ?? [];
};

export const moderateProposal = (
  args: ModerateArgs
): Promise<ProposalActionResponse> =>
  postAction<ProposalActionResponse>({ action: 'moderate', ...args });
